import { useMutation } from "@tanstack/react-query";
import { checkPerformanceStatusApi } from "@/API/checkPerformanceStatusApi";

export const useCheckPerformanceStatus = () => {
  return useMutation({
    mutationFn: (transactionId: string) =>
      checkPerformanceStatusApi(transactionId),
  });
};
